import type { ReactNode } from 'react'
import NoData from '@/components/common/NoData'
import useTranslation from '@/hooks/useTranslation'
import classes from './grid-theme.module.scss'

interface GridEmptyStateProps {
  message?: string
  children?: ReactNode
}

const GridEmptyState = ({ message, children }: GridEmptyStateProps) => {
  const { t } = useTranslation()

  return (
    <div className={classes.emptyState}>
      {/* commonStatusNoData is the wording the config pages already use for an
          empty list, so the grid's own fallback matches rather than adding a
          third key that says the same thing. */}
      {children ?? <NoData text={message ?? t('commonStatusNoData')} height={180} />}
    </div>
  )
}

export default GridEmptyState
